export default __webpack_public_path__ + "files/2632970a95e162a12233f6dc249f1839.svg";